import { Stack } from '@mui/material';
import { PageContainer } from 'src/components/page-container';
import LogisticaSyncControls from './logistica-sync-controls';
import FicSyncControls from './fic-sync-controls';

export default function ControlsPage() {
  return (
    <PageContainer variant="data">
      <Stack spacing={3}>
        <LogisticaSyncControls />
        <FicSyncControls />
      </Stack>
    </PageContainer>
  );
}
